@if (sideNavItem.externalLink) {
	<div>
		@if (!sideNavItem.disable && !sideNavItem.sideItemMenuHidden) {
			<a class="nav-link" [href]="sideNavItem.link" [target]="sideNavItem.target">
				@if (sideNavItem.icon) {
					<div class="nav-link-icon">
						@if (isFeatherIcon) {
							<i-feather [name]="sideNavItem.icon"></i-feather>
						} @else {
							<fa-icon [icon]="sideNavItem.icon" class="fa-w-18"></fa-icon>
						}
					</div>
				}
				{{ sideNavItem.text }}
				@if (validateNew(sideNavItem)) {
					<div class="badge bg-primary ms-2">
						<fa-icon [icon]="genderless" class="fa-brief"></fa-icon>
					</div>
				}
				@if (sideNavItem.brief) {
					<div class="ms-2"><fa-icon [icon]="genderless" class="fa-brief"></fa-icon></div>
				}
			</a>
		}
	</div>
} @else {
	@if (!sideNavItem.disable && !sideNavItem.sideItemMenuHidden) {
		<a class="nav-link" (click)="toggle()" [ngClass]="{ active: isActive, collapsed: collapsed }">
			@if (sideNavItem.icon) {
				<div class="nav-link-icon">
					@if (isFeatherIcon) {
						<i-feather [name]="sideNavItem.icon"></i-feather>
					} @else {
						<fa-icon [icon]="sideNavItem.icon" class="fa-w-18"></fa-icon>
					}
				</div>
			}
			{{ sideNavItem.text }}
			@if (validateNew(sideNavItem)) {
				<div class="fa-brief animated pulse">
					<fa-icon
						[icon]="genderless"
						ngbPopover="Tem novidade!"
						placement="top"
						container="body"
						triggers="mouseenter:mouseleave"
					></fa-icon>
				</div>
			}
			@if (sideNavItem.brief) {
				<div class="ms-2"><fa-icon [icon]="genderless" class="fa-brief"></fa-icon></div>
			}
			<div class="sidenav-collapse-arrow">
				@if (sideNavItem.submenu) {
					<fa-icon class="ms-auto" [icon]="['fas', 'angle-down']"></fa-icon>
				}
			</div>
		</a>
	}
}
<nav class="sidenav-menu-nested nav" #collapsibleSection [ngClass]="{ collapsed: collapsed }">
	@for (submenuItem of sideNavItem.submenu; track submenuItem) {
		<sbpro-side-nav-item
			class="submenu"
			[sideNavItem]="submenuItem"
			[ngClass]="{ collapsed: collapsed }"
			[hierarchy]="hierarchyExtension"
		></sbpro-side-nav-item>
	}
</nav>
